// eslint-disable-next-line import/no-default-export
export default {
  categoryFetchIncludes: ['attributes'],
  fetchImageSizes: [50, 200, 400, 700, 1000, 1500],
  fetchIncludes: ['categories', 'attributes'],
  restrictedAge: 18,
  lowStockThreshold: 10,
}
